import PropertyPanel from './PropertyPanel';
import PropertyPanelItem from './PropertyPanelItem';

PropertyPanel.Item = PropertyPanelItem;

export default PropertyPanel;
